import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Copy } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card, Field, PageHead } from "@/components/common";
import { AgencySettings } from "@/components/admin/AgencySettings";

export default function Impostazioni() {
  const { user } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const embed = `<iframe src="${window.location.origin}/prenota" width="100%" height="1100" style="border:0"></iframe>`;

  const save = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("Le password non coincidono");
    setBusy(true);
    try { await api.post("/auth/change-password", f); toast.success("Password aggiornata"); setF({ current_password: "", new_password: "", confirm: "" }); }
    catch (e2) { toast.error(errMsg(e2)); } finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-impostazioni">
      <PageHead eyebrow="Impostazioni" title="Account e sito web" subtitle={`Accesso come ${user.email}`} />
      <div className="grid lg:grid-cols-2 gap-6">
        <AgencySettings />
        <Card className="p-6">
          <p className="font-display text-2xl font-semibold text-[#0D3B52] mb-4">Cambia password</p>
          <form onSubmit={save} className="space-y-4">
            <Field label="Password attuale"><Input type="password" value={f.current_password} onChange={set("current_password")} className="bg-white" data-testid="settings-current-password" /></Field>
            <Field label="Nuova password" hint="Minimo 8 caratteri"><Input type="password" value={f.new_password} onChange={set("new_password")} className="bg-white" data-testid="settings-new-password" /></Field>
            <Field label="Conferma nuova password"><Input type="password" value={f.confirm} onChange={set("confirm")} className="bg-white" data-testid="settings-confirm-password" /></Field>
            <Button type="submit" disabled={busy} data-testid="settings-save-password" className="rounded-full bg-[#0D3B52] hover:bg-[#082535]">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Aggiorna password"}</Button>
          </form>
        </Card>
        <Card className="p-6">
          <p className="font-display text-2xl font-semibold text-[#0D3B52] mb-2">Inserisci la prenotazione sul sito</p>
          <p className="text-sm text-[#5C6B73] mb-4">Copia questo codice in una pagina del tuo sito WordPress (blocco "HTML personalizzato") per mostrare il modulo di prenotazione ritiri.</p>
          <pre className="text-xs bg-[#F3EFEA] rounded-lg p-4 whitespace-pre-wrap break-all" data-testid="settings-embed-code">{embed}</pre>
          <Button variant="outline" className="mt-3" onClick={() => { navigator.clipboard.writeText(embed); toast.success("Codice copiato"); }} data-testid="settings-copy-embed"><Copy className="h-4 w-4 mr-1" />Copia codice</Button>
          <p className="text-sm text-[#5C6B73] mt-6">Link diretto da girare a clienti e veterinari:</p>
          <p className="text-sm font-semibold text-[#0D3B52] break-all">{window.location.origin}</p>
        </Card>
      </div>
    </div>
  );
}
